export function fetchUser() {
    return axios.get('/auth/user')
}
